import { useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";
import { useMutation } from "react-query";
import { flattenFeedItemForPost } from "NewsAdmin/utils/flattenFeedItemForPost";
import { flattenFeedItemForAuPost } from "NewsAdmin/utils/flattenFeedItemForAuPost";

export function useFeedPage() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isLoading, isFetching, refetch } = useQuery(
    ["feed"],
    async () => {
      // console.log("Fetching from API...");

      const res = await makeAuthedRequest(`feed`, {
        method: "GET",
      });

      if (res.ok) {
        const json = await res.json();
        //console.log("API Response:", json);
        return json;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    },
    {
      staleTime: 0, // Forces every access to be stale
      refetchOnMount: "always", // Guarantees refetch on page load
      refetchOnWindowFocus: false, // Optional: avoids surprise reloads when user switches tabs
    }
  );

  const cloneFeedItemAU = useMutation(({ feedItem, diamondsList, groupsList }) => {
    const flattened = flattenFeedItemForAuPost(feedItem, diamondsList, groupsList);

    return makeAuthedRequest(`au/clone`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...flattened,
      }),
    }).then(async (res) => {
      if (res.ok) {
        try {
          return await res.json();
        } catch {
          return {}; // fallback if no JSON
        }
      } else {
        let message = "Unknown error";
        try {
          const err = await res.json();
          message = err.message || message;
        } catch {}
        throw new Error(message);
      }
    });
  });

  const syncFeedToAU = useMutation(({ feedItem, diamondsList, groupsList }) => {
    const flattened = flattenFeedItemForAuPost(feedItem, diamondsList, groupsList);

    return makeAuthedRequest(`au/sync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...flattened,
      }),
    }).then(async (res) => {
      if (res.ok) {
        try {
          return await res.json();
        } catch {
          return {}; // fallback if no JSON
        }
      } else {
        let message = "Unknown error";
        try {
          const err = await res.json();
          message = err.message || message;
        } catch {}
        throw new Error(message);
      }
    });
  });

  return {
    data,
    isLoading,
    isFetching,
    refetch,
    cloneFeedItemAU: cloneFeedItemAU.mutate,
    syncFeedToAU: syncFeedToAU.mutate,
    isSaving: cloneFeedItemAU.isLoading || syncFeedToAU.isLoading,
  };
}
